const map = {
	"./bg.json": 4378,
	"./cs.json": 3571,
	"./de.json": 5894,
	"./en.json": 4174,
	"./hr.json": 6759,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./lt.json": 5449,
	"./pl.json": 1029,
	"./ro.json": 2354,
	"./sk.json": 347,
	"./sl.json": 7110,
	"./sr.json": 8912,
	"./uk.json": 5130
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7066;